import { RegionDto } from "@core/types/common.types";
import { parseToProjectStatusDto, parseToProjectStaus, ProjectStatus, ProjectStatusDto } from "@features/project/types/project-status.type";
import { Country, CountryDto, parseToCountry, parseToCountryDto } from "@shared/services/country/types/country.type";
import { toDate } from "date-fns";

export interface ProjectBaseData {
  costCenterNumber: string | null;
  buildingOwner: string | null;
  costCenterRegion: CostCenterRegion | null;
  shortName: string | null;
  emails?: string[] | undefined;
}
export interface ProjectBaseDataDto {
  costCenterNumber: string | null;
  buildingOwner: string | null;
  costCenterRegion: CostCenterRegion | null;
  shortName: string | null;
  emails?: string[] | undefined;
}
export interface CostCenterRegion {
  number: string;
  localizedName: string;
}
export interface ProjectDetails {
  readonly number: string;
  name: string;
  status: ProjectStatus;
  plannedStart: Date;
  plannedEnd: Date;
  image: string | null;
  address: ProjectAddress;
  baseData: ProjectBaseData;
}
export interface ProjectDetailsDto extends ProjectStatusDto {
  readonly number: string;
  name: string;
  plannedStart: string;
  plannedEnd: string;
  image: string | null;
  address: ProjectAddressDto;
  baseData: ProjectBaseDataDto;
}
export interface ProjectAddressDto {
  streetOne: string;
  streetTwo?: string | undefined;
  zipCode: string;
  city: string;
  country: CountryDto;
  region?: RegionDto | undefined;
}
export interface ProjectAddress {
  streetOne: string;
  streetTwo?: string | undefined;
  zipCode: string;
  city: string;
  country: Country;
  region?: RegionDto | undefined;
}
export function parseToProjectBaseData (value: ProjectBaseDataDto): ProjectBaseData {
  return {
    buildingOwner: value.buildingOwner,
    costCenterNumber: value.costCenterNumber,
    costCenterRegion: value.costCenterRegion,
    shortName: value.shortName,
    emails: value.emails
  };
}
export function parseToProjectBaseDataDto (value: ProjectBaseData): ProjectBaseDataDto {
  return {
    buildingOwner: value.buildingOwner,
    costCenterNumber: value.costCenterNumber,
    costCenterRegion: value.costCenterRegion,
    shortName: value.shortName,
    emails: value.emails
  };
}
export function parseToProjectDetails (value: ProjectDetailsDto): ProjectDetails {
  return {
    status: parseToProjectStaus(value),
    address: {
      city: value.address.city,
      country: parseToCountry(value.address.country),
      streetOne: value.address.streetOne,
      streetTwo: value.address.streetTwo,
      zipCode: value.address.zipCode,
      region: value.address.region
    },
    number: value.number,
    baseData: parseToProjectBaseData(value.baseData),
    name: value.name,
    image: value.image,
    plannedEnd: toDate(value.plannedEnd),
    plannedStart: toDate(value.plannedStart)
  };
}
export function parseToProjectDetailsDto (value: ProjectDetails): ProjectDetailsDto {
  const projectStatus: ProjectStatusDto = parseToProjectStatusDto(value.status);

  return {
    ...projectStatus,
    number: value.number,
    name: value.name,
    image: value.image,
    plannedStart: value.plannedStart.toISOStringDate(true),
    plannedEnd: value.plannedEnd.toISOStringDate(true),
    baseData: parseToProjectBaseDataDto(value.baseData),
    address: {
      streetOne: value.address.streetOne,
      streetTwo: value.address.streetTwo ?? undefined,
      zipCode: value.address.zipCode,
      city: value.address.city,
      country: parseToCountryDto(value.address.country),
      region: value.address.region ?? undefined
    }
  };
}
